<div class="testimonials-box">
    <div class="person">
        <img [src]="avatar" alt="Avatar name" class="avatar">

        <div class="description">
            <h5 class="name">{{ name }}</h5>
            <p class="specialty">{{ specialty }}</p>
            <unh-rating [rating]="rating"></unh-rating>

            <p class="content">{{ content }}</p>
        </div>
    </div>
</div>
